import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const TestimonialSlider = ({testimonials}) => {
 

  return (
    <div className=" mt-0 mb-20 py-12 ">
      <h2 className="text-3xl md:text-2xl lg:text-5xl notoh font-bold text-black text-center mb-8 ">
        Testimonials
      </h2>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        // navigation
        // pagination={{ clickable: true }}
        loop={true}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className=" w-[90%] lg:w-full "
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index} className="flex justify-center cursor-pointer ">
            <div className="min-w-[250px] lg:min-w-[400px] bg-gradient-to-r from-[#1408ff] to-[#0066ff] rounded-lg p-[1px] shadow-lg h-[390px] lg:h-[350px]">
              <div className="h-full bg-white p-6 rounded-lg text-black flex flex-col justify-between">
                {/* Stars */}
                <div className="mb-4 flex space-x-1 text-blue-500">
                  {Array(item.stars)
                    .fill("★")
                    .map((star, i) => (
                      <span key={i}>{star}</span>
                    ))}
                </div>

                {/* Message */}
                <p className="italic text-sm md:text-base mb-6 flex-1">
                  &ldquo;{item.message}&rdquo;
                </p>

                {/* Name and Role at the Bottom */}
                <div className="mt-auto">
                  <h4 className="font-bold text-base">{item.name}</h4>
                  <p className="text-sm text-blue-500">{item.role}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TestimonialSlider;
